var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('HeadMenu'),_c('router-view'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }